<template>
  <b-modal id="add-apiKey-modal" size="md" :title="$translate('Add API key')" hide-footer centered content-class="rounded-8" @close="clear">
    <div v-if="token" class="row">
      <div class="col-12">
        <div style="margin: 10px 0">{{ 'Your access token' | i18n }}:</div>
        <div style="font-weight: 500; word-break: break-all">
          {{ token }}
        </div>
        <div style="margin: 10px 0">
          {{ 'Please save the token to a secure place After closing this window this token will not be shown again' | i18n }}
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div :class="`col-12 col-lg-12 col-sm-12 col-xs-12`">
        <Input v-model="name" form-group-id="name" placeholder="name" :required="true" />
      </div>
      <div class="row w-100 mx-0">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between">
          <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-5" @click="close">
            {{ 'Close' | i18n }}
          </b-button>
          <b-button variant="outline-primary" size="lg" class="btn-delete-device px-5" :disabled="!name" @click="onSubmit">
            {{ 'Save' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import { ApiManagementMixin, NotificationMixin } from '../../../../mixins';

export default {
  title: 'AddAPIKey',
  components: { Input },
  mixins: [ApiManagementMixin, NotificationMixin],
  props: {
    getPage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      token: null,
    };
  },
  methods: {
    close() {
      this.$root.$emit('bv::hide::modal', 'add-apiKey-modal');
    },
    clear() {
      this.name = '';
      this.token = null;
    },
    async onSubmit() {
      try {
        const result = await this.apiManagementService.create({ name: this.name });
        this.token = result.data;
        await this.getPage();
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep .button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.center-color {
  justify-content: center;
  align-items: center;
  display: flex;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
